// 环境配置（简化方案：使用相对路径，通过 Nginx/Vite 代理）
// 参考 shubing_pc 项目的方案：开发环境通过 Vite 代理，生产环境通过 Nginx 代理

// 判断是否为开发环境（仅在 localhost）
const isDevelopment = typeof window !== 'undefined' 
  ? (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
  : (process.env.NODE_ENV !== 'production');

const config = {
  // 开发环境配置（API 走代理，媒体文件直连后端避免代理 404）
  development: {
    apiBaseUrl: '',  // 使用相对路径，通过 setupProxy 代理到后端
    mediaBaseUrl: process.env.REACT_APP_BACKEND_HOST && process.env.REACT_APP_BACKEND_PORT
      ? `http://${process.env.REACT_APP_BACKEND_HOST}:${process.env.REACT_APP_BACKEND_PORT}`
      : 'http://localhost:8000',  // 验证码等媒体直连后端，避免 /media 代理 404
    difyWebBaseUrl: process.env.REACT_APP_DIFY_WEB_BASE_URL || '',
  },
  
  // 生产环境配置（通过 Nginx 代理到后端）
  production: {
    apiBaseUrl: '',  // 使用相对路径，通过 Nginx 代理
    mediaBaseUrl: '',  // 使用相对路径，通过 Nginx 代理
    difyWebBaseUrl: process.env.REACT_APP_DIFY_WEB_BASE_URL || '',
  }
};

// 根据当前环境获取配置
const env = isDevelopment ? 'development' : 'production';
const currentConfig = config[env];

// 导出配置
export const API_BASE_URL = currentConfig.apiBaseUrl;
export const MEDIA_BASE_URL = currentConfig.mediaBaseUrl;
export const DIFY_WEB_BASE_URL = currentConfig.difyWebBaseUrl;

// 拼接 Dify 控制台外链（需配置 REACT_APP_DIFY_WEB_BASE_URL）
export const buildDifyWebUrl = (path = '') => {
  const base = (DIFY_WEB_BASE_URL || '').trim().replace(/\/$/, '');
  if (!base) return '';
  if (!path) return base;
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
};

// 获取完整的API URL
export const getApiUrl = (endpoint) => {
  if (endpoint.startsWith('http')) {
    return endpoint;
  }
  return `${API_BASE_URL}${endpoint.startsWith('/') ? endpoint : `/${endpoint}`}`;
};

// 获取媒体文件URL
export const getMediaUrl = (path) => {
  if (path.startsWith('http')) {
    return path;
  }
  return `${MEDIA_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

// 调试信息
console.log('当前环境:', env);
console.log('API基础URL:', API_BASE_URL);
console.log('媒体基础URL:', MEDIA_BASE_URL);
console.log('DIFY_WEB_BASE_URL:', DIFY_WEB_BASE_URL);

export default currentConfig; 